import { render } from "./LookupLang.vue?vue&type=template&id=56137fd4&ts=true"
import script from "./LookupLang.vue?vue&type=script&lang=ts"
export * from "./LookupLang.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__